export const NoPointers = Object.freeze({ mandatory: false, exclusive: false, accepts: [] });
